module.exports = __webpack_public_path__ + "static/media/store-Spotify.4456214a.svg";